import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="container my-5">
      <h1 className="mb-3">TERMS & CONDITIONS </h1>

      <section className="my-5">
        <h3 className="mb-3">GENERAL TERMS & CONDITIONS </h3>
        <div className="mb-5">
          <h5 className="mb-3">Introduction</h5>
          <p>
            1.1 Ileero Pay Limited operates two services. Ileero Remit that
            allows you to transfer money internationally through our website
            (https://www.ileeropay.com) and mobile app (the “Service”) and
            Ileero Business which is an acquiring service that allows businesses
            and merchants to capture Payments wherever they are using mobile
            equipment. It also features a micro shop that businesses can use to
            sell their products.
          </p>
          <p>
            1.2 In the present Terms and Conditions the terms ”Ileero ” “we”,
            “us”, “our” refer to Ileero Pay Limited together with its employees,
            directors, affiliates, successors{" "}
          </p>
          <p>
            1.3 All references to ‘you’ or ‘your’ within these Terms and
            Conditions are deemed to refer to the User of our Service whether as
            Senders, Recipients, or visitors to our website or mobile
            application.
          </p>
          <p>
            1.4 These Terms and Conditions are effective from the date on which
            you first access, register or use the Service. These Terms and
            Conditions are subjected to change as the need arise.{" "}
          </p>
          <p>
            1.5 Your use of the Site and Service (including accessing, browsing,
            or registering to use the Site) confirms your unconditional
            agreement to be bound by these Terms and Conditions and is subject
            to your continued compliance with these Terms.
          </p>
          <p>
            1.6 It is important that you understand that access and use of the
            Service is conditional on your acceptance of present Terms and
            Conditions.{" "}
          </p>
          <p>
            1.7 We reserve the right to revise these Terms and Conditions at any
            time by amending this page without notice and your continued use of
            the Site after any such amendments are published on the Site will be
            considered acceptance by you of such amended Terms and Conditions.
            Updated Terms and Conditions will supersede all previous versions of
            the Terms and Conditions. Please check this page regularly to take
            notice of any changes we have made, as they are binding to you.
          </p>
          <div className="changed-section ">
            <p className="">
              1.8 There are other terms that may apply to you. These terms of
              use refer to the following additional terms, which also apply to
              your
            </p>
            use of our site:
            <ul>
              <li>
                Our Privacy Policy, which sets out the terms on which we process
                any personal data we collect from you, or that you provide to
                us. Our Privacy Policy: [
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.ileeropay.com/privacy-policy"
                >
                  https://www.ileeropay.com/privacy-policy
                </a>
                ]
              </li>
              <li>
                By using our site, you consent to such processing and you
                warrant that all data provided by you is accurate.
              </li>
              <li>
                Our Cookie Policy, which sets out information about the cookies
                on our site.{" "}
              </li>
            </ul>
            <p>1.9 We may suspend or withdraw our site.</p>
            <p>1.10 Our site is made available free of charge.</p>
            <p>
              1.11 We do not guarantee that our site, or any content on it, will
              always be available or be uninterrupted. We may suspend or
              withdraw or restrict the availability of all or any part of our
              site for business and operational reasons. We will try to give you
              reasonable notice of any suspension or withdrawal.{" "}
            </p>
            <p>
              1.12 You are also responsible for ensuring that all persons who
              access our site through your internet connection are aware of
              these terms of use and other applicable terms and conditions, and
              that they comply with them.
            </p>
          </div>
        </div>

        <div className="mb-5">
          <h5 className="mb-3">Information About Us</h5>
          <p>
            2.1 Ileero Pay Limited operates a website (the Website) and a mobile
            phone application that enables you to transfer money using a device
            connected to the Internet and/or a mobile phone.{" "}
          </p>
          <p>
            2.2 It is a company incorporated and licensed under the laws of the
            United Kingdom, (company number 12613378) engaged in the business of
            Money Remittance and Business Acquiring. Our Registered Office
            address is Ileero Pay Limited, No 33 Mountview House, 202-212 High Rd, Ilford IG1 1QB{" "}
          </p>
          <p>
            E-mail Address is:{" "}
            <a href="mailto: info@ileero.com"> info@ileero.com</a>{" "}
          </p>
          <p>
            Website is:{" "}
            <a
              href="https://www.ileeropay.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.ileeropay.com
            </a>{" "}
          </p>

          <p>
            2.3 Ileero Pay Limited is regulated by the Financial Conduct Authority
            (FCA 929773){" "}
          </p>
        </div>

        <div className="mb-5">
          <h5 className="mb-3">Confidentiality/ Privacy</h5>
          <p>
            3.1 As a fully regulated institution and with a purpose of providing
            the Service we are bound by the legal requirements to obtain,
            verify, and record information about our customers. Therefore, we
            may request from you or consult any legal sources to obtain your
            personal data when offering the Service to you.
          </p>
          <p>
            3.2 Your personal information will be treated and processed securely
            and strictly in accordance with applicable laws and regulations. We
            will not treat customer information as confidential where it is
            already public knowledge or where it becomes public knowledge
            through no fault of our own.{" "}
          </p>
          <p>
            3.3 We may disclose customer information if we are required to do so
            by law, by court order, by any statutory, legal, or regulatory
            requirement, by the police or any other competent authorities in
            connection with the prevention or detection of crime or to help
            combat fraud, money laundering and terrorism financing. We may also
            report suspicious activity to appropriate competent law enforcement
            or government authorities.{" "}
          </p>
        </div>

        <div className="mb-5">
          <h5 className="mb-3">Eligibility And Your Access Right</h5>
          <p>
            4.1 You must be at least eighteen (18) years old to access or use
            the Service as a Sender. You must be able to enter legally binding
            contracts under applicable law, including local law in the
            jurisdiction in which you live.
          </p>
          <p>
            {" "}
            4.2 Without prejudice to your rights in relation to any order for
            Services in relation to which we issued a Confirmation (in
            accordance with clause 7 below), we reserve the right, at any time,
            to terminate or suspend your access to the Service without prior
            notice if:
          </p>
          <ul>
            <li>
              You use the Service or attempt to use it for any Prohibited
              Purpose.
            </li>
            <li>
              You attempt to transfer or charge funds from an account that does
              not belong to you
            </li>
            <li>
              We receive conflicting claims regarding ownership of or the right
              to withdraw funds from a debit or credit card account.{" "}
            </li>
            <li>
              You have provided us with false evidence of your identity, or you
              keep failing in providing us with a true, accurate, current, and
              complete evidence of your identity or details regarding
              transactions.
            </li>
            <li>
              You attempt to tamper, hack, modify, overload, or otherwise
              corrupt or circumvent the security and/or functionality of the
              Website and/or the Application or to infect it with any Malicious
              Code.
            </li>
            <li>You are in breach of these Terms and Conditions. </li>
            <li>
              We have reason to believe that any of the foregoing has occurred
              or is likely to occur, or a Compliance Officer has taken a
              discretionary decision to do so.
            </li>
          </ul>
        </div>
        <div className="mb-5">
          <h5 className="mb-3">Our Obligation </h5>
          <p>
            5.1. Before your transaction is complete your will be provided with
            the following information: For Ileero Remit
          </p>
          <ul>
            <li>The amount the beneficiary will receive,</li>
            <li>The maximum total Fee that you will be charged,</li>
            <li>An exchange rate that we will apply to your transaction</li>
          </ul>
          <p>For Ileero Business</p>
          <ul>
            <li>The maximum total Fee that you will be charged,</li>
            <li>Details of the goods you have ordered. </li>
          </ul>

          <p>
            5.2 We reserve the right to refuse to perform any of the Services
            (including after Confirmation) if:
          </p>
          <ul>
            <li>
              We are unable to obtain satisfactory evidence of your identity.
            </li>
            <li>
              You provide us with false, incorrect, or incomplete information.
            </li>
            <li>
              We are unable to reach you via contact details provided by you.
            </li>
            <li>
              Your transfer order, information or documentation is not provided
              sufficiently in advance to allow us to process it in accordance
              with your request.
            </li>
            <li>
              You attempt to tamper, hack, modify, overload, or otherwise
              corrupt or circumvent the security and/or functionality of the
              Website and/or the Application or to infect it with any Malicious
              Code.
            </li>
            <li>You are in breach of these Terms and Conditions.</li>
            <li>
              You or the order you placed are in breach of any applicable laws
              or regulations or are made for a Prohibited Purpose.
            </li>
            <li>
              Processing the Service in accordance with your order may expose us
              to liability.
            </li>
            <li>
              We are unable to process your transfer due to variations in
              business hours, currency exchange or currency availability issues.
            </li>
            <li>
              We have reason to believe that any of the foregoing has occurred
              or is likely to occur; or
            </li>
            <li>
              A Compliance Officer has taken a discretionary decision to do so.
            </li>
          </ul>
        </div>

        <p>
          5.3 We shall not be liable for any damages, costs or losses incurred
          by the customer or any third party if, as a result of any of the
          circumstances referred to in clause 4.2 or 5.2 above, we fail to
          complete the transfer of funds in accordance with an order.{" "}
        </p>

        <div className="mb-5">
          <h5 className="mb-3">
            Information Provided After We Process a Transaction
          </h5>
          <p>
            6.1 After we process your transaction to the Recipient an e-mail
            will be sent to you with the following information:
          </p>
          <p>For Ileero Remit</p>

          <ul>
            <li>transaction reference number,</li>
            <li>
              confirmation of the exact amount we are sending to the Recipient
              on your behalf in both pay in
            </li>
            <li>and pay out currencies,</li>
            <li>confirmation of the Fee that has been charged,</li>
            <li>An exchange rate applied to your transaction,</li>
            <li>confirmation of the bank to which the money has been sent</li>
            <li>
              An estimated time when the money will be available to the
              Recipient.
            </li>
          </ul>
          <p>For Ileero Business</p>
          <ul>
            <li>Transaction reference number,</li>
            <li>Confirmation of the exact product you have purchased</li>
            <li>An estimated time when the product will be delivered.</li>
          </ul>
        </div>

        <div className="mb-5">
          <h5 className="mb-3">Cancellations and Refunds</h5>
          <p>
            7.1 If you exercise your right to cancel the order after you have
            already paid us the funds to be transferred:
          </p>
          <ul>
            <li>
              we will refund money paid by you only under the condition that it
              has not already been paid out to the Recipient or the goods has
              not been shipped out in accordance with your original instructions
              prior to the cancellation request; and
            </li>
            <li>
              we reserve the right to retain the Fees charged for the Service
              (and we may charge you with those fees if they have not yet been
              paid).{" "}
            </li>
          </ul>
        </div>

        <div className="mb-5">
          <h5 className="mb-3">Complaints/ Feedbacks</h5>

          <p>
            We value your feedback as it helps us improve our service. We have
            established internal Procedures for complaints. You can make a
            complaint in writing to us regarding any aspect of the service by
            mail or e-mail to the following addresses:
          </p>
          <p>
            Email: <a href="mailto:info@ileero.com">info@ileero.com</a>{" "}
          </p>
          <p>
            Address: No 33 Mountview House, 202-212 High Rd, Ilford IG1 1QB.
          </p>
          <p>
            8.2 We will investigate your complaint and come back to you with
            final response by the end of 5 business days after the day in which
            we received a complaint.
          </p>
          <p>Call Us Monday-Saturday 08:00 – 18:00</p>
          <p>Telephone: 0203 011 2409 or 0800 254 5034</p>
          <p>
            Connect with us: <a href="https://www.ileeropay.com"></a>
          </p>
          <p>
            Ileero Pay Limited is regulated by the Financial Conduct Authority (FCA
            929773)
          </p>
          <p>
            Ileero Pay Limited aim to be a leading financial service provider
            promoting financial independence globally
          </p>
        </div>

        <div className="">
          <div className="mb-5">
            <h5 className="mb-3">Do Not Rely On Information on This Site</h5>
            <p>
              9.1. The content on our site is provided for general information
              only. It is not intended to amount to advice on which you should
              rely. You must obtain professional or specialist advice before
              taking, or refraining from, any action on the basis of the content
              on our site.
            </p>
            <p>
              9.2. Although we make reasonable efforts to update the information
              on our site, we make no representations, warranties or guarantees,
              whether express or implied, that the content on our site is
              accurate, complete or up to date.
            </p>
            <p>
              9.3. We are not responsible for websites we link to. Where our
              site contains links to other sites and resources provided by third
              parties, these links are provided for your information only. Such
              links should not be interpreted as approval by us of those linked
              websites or information you may obtain from them. We have no
              control over the contents of those sites or resources.
            </p>
            <p>
              9.4 Nothing on this Site should be construed as a solicitation or
              offer, or recommendation, to acquire or dispose of any investment
              or to engage in any other transaction, or to provide any
              investment advice or service.{" "}
            </p>
          </div>

          <div className="mb-5">
            <h5 className="mb-3">Legal bits and pieces</h5>
            <p>10. 1 Which country's laws apply to any disputes? </p>
            <p>
              If you are a consumer, please note that these terms of use, their
              subject matter and their formation, are governed by English law.
              You and we both agree that the courts of England and Wales will
              have exclusive jurisdiction except that if you are a resident of
              Northern Ireland you may also bring proceedings in Northern
              Ireland, and if you are resident of Scotland, you may also bring
              proceedings in Scotland.
            </p>
            <p>
              10.2 If you are a business, these terms of use, their subject
              matter and their formation (and any non-contractual disputes or
              claims) are governed by English law. We both agree to the
              exclusive jurisdiction of the courts of England and Wales.
            </p>
          </div>

          <div className="mb-5">
            <h5 className="mb-3">Copyright</h5>
            <p>
              11.1 The entire design and content of this Site is the copyright
              of Ileero Pay Limited, or its licensors, and all rights are
              reserved. You may not download, reproduce, transmit or modify any
              part of this Site without our prior written permission. You may
              only print out parts of this Site for your own internal business
              purpose.
            </p>
            <p>
              ILEERO REMIT is a UK registered trade mark of Ileero Pay. You are
              not permitted to use it without our approval.{" "}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
